module.exports = __webpack_public_path__ + "static/media/S6_01.57443081.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/STAGE6strobe/S6_01.png
// module id = 203
// module chunks = 0